export const KARIGAR_SALARY_REPORT_REQUEST = 'KARIGAR_SALARY_REPORT_REQUEST';
export const KARIGAR_SALARY_REPORT_SUCCESS = 'KARIGAR_SALARY_REPORT_SUCCESS';
export const KARIGAR_SALARY_REPORT_FAILURE = 'KARIGAR_SALARY_REPORT_FAILURE';
export const KARIGAR_SALARY_FILTER_REPORT_REQUEST = 'KARIGAR_SALARY_FILTER_REPORT_REQUEST';
export const KARIGAR_SALARY_FILTER_REPORT_SUCCESS = 'KARIGAR_SALARY_FILTER_REPORT_SUCCESS';
export const KARIGAR_SALARY_FILTER_REPORT_FAILURE = 'KARIGAR_SALARY_FILTER_REPORT_FAILURE';